export default __webpack_public_path__ + "static/media/logo.bbf62641.svg";